<script setup lang="ts">
    import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';

    const props = defineProps<{
        employee: Employee;
        data: ChangedFields;
    }>();

    const values = computed(() => {
        return [
            { name: 'bank_reg', group: 'bank', key: 'bank' },
            { name: 'bank_account', group: 'bank', key: 'bank' },
        ];
    });
</script>

<template>
    <EmployeeChangesGroup
        :data="data"
        :values="values"
        :employee="employee"
    />
</template>
